<template>
    <div style="height: 100%;">
        <router-view/>
        <van-tabbar v-model="active" :placeholder="true" :safe-area-inset-bottom="true">
            <van-tabbar-item replace to="/headstaff" icon="orders-o">
                <span>我的客人</span>
            </van-tabbar-item>
            <van-tabbar-item replace to="/mydata" icon="chart-trending-o">
                <span>我的数据</span>
            </van-tabbar-item>
        </van-tabbar>
    </div>
    </template>
    <script>
        export default {
            data(){
                return {
                    active:0,
                }
            }
        }
    </script>


// WEBPACK FOOTER //
// src/page/intebo/intebocashtabbar.vue